import { Partner } from "../../../../shared/models/partner";

export class PartnerShareFacebookConnectionDialogData {
  constructor(public readonly partner: Partner) {}
}
